import { useState, useMemo, useCallback, useEffect } from 'react';

function useFormHandling(initialValues, validator) {
    const [formValues, setFormValues] = useState({ ...initialValues });
    const initialTouchedValues = useMemo(() => {
        return Object.keys(initialValues).reduce((acc, key) => {
            acc[key] = false;
            return acc;
        }, {});
    }, [initialValues]);
    const [touched, setTouched] = useState(initialTouchedValues);
    const validateNameInKeys = useCallback(function (name) {
        const keys = Object.keys(initialValues);
        if (typeof name !== 'string' || !keys.includes(name))
            throw new Error(`invalid target name: "${name}"`);
    }, [initialValues]);
    useEffect(() => {
        setFormValues({
            ...initialValues,
        });
    }, [initialValues]);
    const handleChange = useCallback((ev) => {
        if (ev.persist)
            ev.persist();
        const { target: { name, value }, } = ev;
        validateNameInKeys(name);
        setFormValues(currentValues => ({
            ...currentValues,
            [name]: ev.target instanceof HTMLInputElement && ev.target.type === 'checkbox' ? ev.target.checked : value,
        }));
    }, [validateNameInKeys]);
    const handleBlur = useCallback((ev, isTouched = true) => {
        const { name } = ev.target;
        validateNameInKeys(name);
        setTouched(currentlyTouched => ({
            ...currentlyTouched,
            [name]: isTouched,
        }));
    }, [validateNameInKeys]);
    const errors = useMemo(() => validator(formValues), [validator, formValues]);
    const isFormValid = Object.keys(errors).length === 0;
    const resetForm = useCallback(() => {
        setTouched(initialTouchedValues);
        setFormValues({
            ...initialValues,
        });
    }, [initialTouchedValues, initialValues]);
    return {
        formValues,
        handleChange,
        touched,
        handleBlur,
        errors,
        isFormValid,
        resetForm,
    };
}

export { useFormHandling };
